import { Button } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import Configuracao from "../../utils/Configuracao";
import BotaoAssinar from './BotaoAssinar';
import BotaoDistribuir from './BotaoDistribuir';
import BotaoImportar from './BotaoImportar';
import BotaoVisto from './BotaoVisto';
import ListaCountProcessosPorServidor from './ListaCountProcessosPorServidor';
import UsuarioStore from '../../store/UsuarioStore';
import RouterStore from '../../store/RouterStore';
import { ControleGabinete } from '../../modelo';
import { Gavel } from '@mui/icons-material';
import ControleGabineteStore from '@/store/ControleGabineteStore';
import { action, observable, makeObservable } from 'mobx';

const botaoImportar = 1;
const ListagemServidores = 2;
const botaoDistribuir = 3;
const botaoAssinar = 4;
const botaoVisto = 5;
const botaoAguardandoJulgamento = 6;

// Tipos que têm um botão de ação próprio no card (Importar, Distribuir, Assinar, Visto à
// Pauta, Aguardando Julgamento). Qualquer outro tipo — hoje Redator Designado e Votos
// Vencidos, mas vale pra qualquer tipo novo sem botão próprio que apareça depois — cai no
// case default de montaConteudo e também passa a exibir a contagem de processos por
// responsável, em vez de só o texto "N - Descrição".
const TIPOS_COM_BOTAO_PROPRIO = [
    botaoImportar,
    botaoDistribuir,
    botaoAssinar,
    botaoVisto,
    botaoAguardandoJulgamento
];

const mockServidoresBloco = [
    { nome: 'Nome Responsável', count: 1 },
    { nome: 'Nome Responsável', count: 2 },
    { nome: 'Nome Responsável', count: 10 },
    { nome: 'Nome Responsável', count: 40 },
    { nome: 'Nome Responsável', count: 100 }
];
const mockServidoresLista = [{ nome: 'Nome Responsável', count: 1 }];

interface IPropsCard {
    // callBackAtualizarItems: (any) => any
    isConfig?: boolean;
    card: ControleGabinete;
    visualizandoKanban: boolean
    apenasProcessos: boolean;
}


class CardConteudo extends React.Component<IPropsCard> {
    expandido = false;
    possuiMaisDeUmServidor = false;

    constructor(props: IPropsCard) {
        super(props);

        makeObservable(this, {
            expandido: observable,
            possuiMaisDeUmServidor: observable,
            toggleExpandir: action,
            setPossuiMaisDeUmServidor: action
        });
    }

    get servidoresMockConfiguracao() {
        return ControleGabineteStore.isVisualizacaoEmLista
            ? mockServidoresLista
            : mockServidoresBloco;
    }

    renderConteudoComEstadoConfiguracao = (conteudo: React.ReactNode) => {
        if (!this.props.isConfig) {
            return conteudo;
        }

        return (
            <div
                style={{
                    pointerEvents: 'none',
                    filter: 'grayscale(1)',
                    opacity: 0.65
                }}
            >
                {conteudo}
            </div>
        );
    }

    renderListaPorResponsavel() {
        return (
            <ListaCountProcessosPorServidor isConfig={this.props.isConfig}
                controleTitulo={this.props.card.descricao}
                controleNumero={this.props.card.numero} servidoresMock={this.servidoresMockConfiguracao}
                onDetectarQuantidadeServidores={this.setPossuiMaisDeUmServidor}
            />
        );
    }

    montaConteudo(id) {
        switch (id) {
            case botaoImportar:
                return this.renderConteudoComEstadoConfiguracao(
                    <BotaoImportar forcarImportar={false} origemImportacaoGE='Controle de Gabinete' processosParaImportar={[]} />
                );
            case ListagemServidores:
                return this.renderListaPorResponsavel();
            case botaoDistribuir:
                return this.renderConteudoComEstadoConfiguracao(
                    <div title="Selecionar processos para movimentação">
                        <BotaoDistribuir />
                    </div>
                );
            case botaoAssinar: {
                const podeAssinar = UsuarioStore.usuarioTemPapel(Configuracao.PERFIL_MAGISTRADO) || UsuarioStore.usuarioTemPapel(Configuracao.PERFIL_SECRETARIO);
                return this.renderConteudoComEstadoConfiguracao(
                    podeAssinar ? <BotaoAssinar /> : <BotaoAssinar disabled={true} />
                );
            }
            case botaoVisto:
                return this.renderConteudoComEstadoConfiguracao(<BotaoVisto />);
            case botaoAguardandoJulgamento:
                return this.renderConteudoComEstadoConfiguracao(
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Gavel />}
                        onClick={() => {
                            RouterStore.push("/escaninho/julgamento");
                        }}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '50px',
                            fontWeight: 600,
                            fontSize: '0.875rem',
                            paddingX: '18px',
                            paddingY: '8px',
                            minHeight: '40px',
                            boxShadow: 'none',
                            '&:hover': {
                                boxShadow: 'none',
                            }
                        }}
                    >
                        Visualizar
                    </Button>
                );
            default:
                // Tipos sem botão de ação própria (ex.: Redator Designado, Votos Vencidos):
                // mostra a contagem por responsável em vez do texto fixo "N - Descrição".
                return this.renderListaPorResponsavel();
        }
    }

    toggleExpandir = () => {
        this.expandido = !this.expandido;
    };

    setPossuiMaisDeUmServidor = (valor: boolean) => {
        this.possuiMaisDeUmServidor = valor;
    };

    handleCliqueNoCorpoConteudo = (event: React.MouseEvent<HTMLElement>, podeExpandir: boolean) => {
        if (!podeExpandir) {
            return;
        }

        const alvo = event.target as HTMLElement;
        const clicouEmElementoInterativo = !!alvo.closest(
            '.item-conteudo, button, a, [role="button"], input, select, textarea, label'
        );

        if (clicouEmElementoInterativo) {
            return;
        }

        this.toggleExpandir();
    };

    render() {
        const isLista = ControleGabineteStore.isVisualizacaoEmLista;
        // Cards que exibem a lista de processos por responsável: os de Listagem e os "contador
        // simples" sem botão próprio (ver TIPOS_COM_BOTAO_PROPRIO), que também podem precisar
        // expandir/recolher quando têm mais de um responsável.
        const possuiListaPorResponsavel = !TIPOS_COM_BOTAO_PROPRIO.includes(this.props.card.tipo.id);
        const limiteLista = 50;
        const podeExpandir = isLista && possuiListaPorResponsavel && this.possuiMaisDeUmServidor;
        const isConfigLista = isLista && this.props.isConfig;

        const estiloConteudo = isLista
            ? {
                maxHeight: this.expandido ? 'none' : `${limiteLista}px`,
                overflow: this.expandido ? 'visible' : 'hidden'
            }
            : {
                maxHeight: '200px',
                overflow: 'auto'
            };

        return (
            <div
                className="card-conteudo-wrapper"
                style={{
                    display: isLista ? 'flex' : 'block',
                    alignItems: 'center',
                    width: '100%',
                    position: 'relative'
                }}
            >
                <div
                    className="w3-container card-conteudo"
                    onClick={(event) => this.handleCliqueNoCorpoConteudo(event, podeExpandir)}
                    style={{
                        display: 'flex',

                        justifyContent:
                            isLista && possuiListaPorResponsavel
                                ? 'center'
                                : 'center',
                        cursor: podeExpandir ? 'pointer' : 'default',
                        flex: 1,
                        width: '100%',
                        fontSize: '11px',
                        ...estiloConteudo
                    }}
                >
                    {this.montaConteudo(this.props.card.tipo.id)}
                </div>

                {!isConfigLista && podeExpandir && (
                    <div
                        className="ver-mais-lateral"
                        onClick={this.toggleExpandir}
                        title="Expandir / recolher"
                        style={{
                            position: 'absolute',
                            right: 12,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            userSelect: 'none',
                            zIndex: 2
                        }}
                    >
                        {this.expandido ? '▲' : '▼'}
                    </div>
                )}
            </div>
        );
    }
}

export default observer(CardConteudo);
